import { fontWeightRegular } from '@/constants'

export default function Tooltip() {
	return {
		MuiTooltip: {
			styleOverrides: {
				tooltip: ({ theme }) => ({
					fontSize: '1rem',
					fontWeight: fontWeightRegular,
					backgroundColor: theme.palette.secondary.main,
					color: theme.palette.secondary.contrastText,
					...theme.applyStyles('light', {
						boxShadow: theme.shadows[8],
					}),
				}),
			},
		},
	}
}
